import {useEffect, useState} from "react";
import baseUrl from "../../baseUrl";

// С2 — „запази това на екрана си".
//
// Геодезистът поиска получателят на линка да може да го закачи като икона, а не
// да го търси всеки път из пощата. Затова страницата се държи като приложение:
// собствен манифест ЗА ТОЗИ ТОКЕН (иконата отваря точно неговата справка) и
// service worker, без който Chrome не предлага закачане.
//
// Трите пътя са различни и не могат да се слеят:
//   • Chrome/Edge (Android и компютър) дават `beforeinstallprompt` — истински
//     бутон, едно натискане.
//   • Safari на iPhone/iPad НЕ дава такова събитие. Apple не позволява бутон;
//     остава упътване към „Сподели → Добави към началния екран".
//   • Останалите (Firefox и др.) — упътване към менюто на браузъра.
// Затова се показва това, което наистина ще проработи, вместо бутон, който на
// половината устройства не прави нищо.
//
// QR кодът е за третия случай: линкът е дошъл на компютъра, а човекът го иска
// на телефона си.

export const наIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    // iPadOS се представя за Mac; издава го това, че има допир.
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export const вечеЗакачено = () =>
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator.standalone === true;

export const SaveToDevice = ({token, companyName}) => {
    const [prompt, setPrompt] = useState(null);
    const [показваQr, setПоказваQr] = useState(false);
    const [показваУпътване, setПоказваУпътване] = useState(false);
    const [закачено, setЗакачено] = useState(вечеЗакачено());

    // Манифестът е за ТОЗИ токен — слага се от кода, защото токенът се знае
    // чак тук. Маха се при напускане, за да не остане закачен за друга страница.
    useEffect(() => {
        const link = document.createElement("link");
        link.rel = "manifest";
        link.href = `${baseUrl()}/public/${token}/manifest.json`;
        document.head.appendChild(link);
        return () => link.remove();
    }, [token]);

    // Service worker-ът е само за да стане страницата „инсталируема"; не кешира.
    // Обхватът е СТЕСНЕН до /p/ — файлът стои в корена на приложението, но няма
    // причина да прихваща и страниците зад вход. Ако някога се счупи, да счупи
    // само публичната страница.
    useEffect(() => {
        if (!("serviceWorker" in navigator)) return;
        const корен = process.env.PUBLIC_URL || "";
        navigator.serviceWorker
            .register(`${корен}/sw.js`, {scope: `${корен}/p/`})
            .catch(() => {});   // без него си остава обикновена страница — не е беда
    }, []);

    useEffect(() => {
        const хвани = (e) => {
            e.preventDefault();     // задържаме го, за да го пуснем от НАШИЯ бутон
            setPrompt(e);
        };
        const закачиха = () => { setЗакачено(true); setPrompt(null); };
        window.addEventListener("beforeinstallprompt", хвани);
        window.addEventListener("appinstalled", закачиха);
        return () => {
            window.removeEventListener("beforeinstallprompt", хвани);
            window.removeEventListener("appinstalled", закачиха);
        };
    }, []);

    if (закачено) return null;

    const закачи = async () => {
        if (!prompt) return;
        prompt.prompt();
        const {outcome} = await prompt.userChoice;
        setPrompt(null);                       // събитието е за еднократна употреба
        if (outcome === "accepted") setЗакачено(true);
    };

    return (
        <div className="border rounded p-3 mb-4"
             style={{background: "rgba(0,0,0,0.02)"}}>
            <div className="d-flex flex-wrap gap-2 align-items-center">
                <strong className="me-1">Запазете това на екрана си:</strong>

                {prompt && (
                    <button className="btn btn-sm btn-success" onClick={закачи}>
                        Добави икона на екрана
                    </button>
                )}
                {!prompt && (
                    <button className="btn btn-sm btn-outline-secondary"
                            onClick={() => setПоказваУпътване(v => !v)}>
                        Как се добавя икона
                    </button>
                )}
                <button className="btn btn-sm btn-outline-secondary"
                        onClick={() => setПоказваQr(v => !v)}>
                    {показваQr ? "Скрий QR кода" : "Отвори на телефон (QR)"}
                </button>
            </div>

            {показваУпътване && !prompt && (
                <div className="mt-3" style={{fontSize: "0.92rem"}}>
                    {наIOS() ? (
                        <>
                            <div className="fw-bold mb-1">iPhone / iPad (Safari)</div>
                            <ol className="mb-0 ps-3">
                                <li>Натиснете бутона „Сподели" (квадратчето със стрелка
                                    нагоре) долу в средата.</li>
                                <li>Плъзнете надолу и изберете
                                    „Добави към началния екран".</li>
                                <li>Натиснете „Добави" горе вдясно.</li>
                            </ol>
                        </>
                    ) : (
                        <>
                            <div className="fw-bold mb-1">Ако няма бутон</div>
                            <ol className="mb-0 ps-3">
                                <li>Отворете менюто на браузъра (трите точки или
                                    трите чертички).</li>
                                <li>Изберете „Добави към началния екран",
                                    „Инсталирай" или „Запази като приложение".</li>
                            </ol>
                            <div className="text-muted mt-2">
                                В Chrome и Edge бутонът излиза сам. Ако ползвате друг
                                браузър, отворете страницата в Chrome — там става с
                                едно натискане.
                            </div>
                        </>
                    )}
                </div>
            )}

            {показваQr && (
                <div className="mt-3 text-center">
                    <img src={`${baseUrl()}/public/${token}/qr.svg`}
                         alt="QR код към тази страница"
                         style={{width: "200px", maxWidth: "60%", height: "auto"}}/>
                    <div className="text-muted mt-1" style={{fontSize: "0.88rem"}}>
                        Насочете камерата на телефона си към кода, за да отворите
                        същата страница там.
                    </div>
                </div>
            )}

            <div className="text-muted mt-2" style={{fontSize: "0.85rem"}}>
                Иконата отваря направо справката на {companyName} — без парола и без
                търсене в пощата. Данните се теглят наново при всяко отваряне; в
                устройството не остава копие.
            </div>
        </div>
    );
};
